import { MessageSquare, BookOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SensitiveDataToggle } from '@/components/sensitive-data';

interface DemoModeHeaderControlsProps {
  showSensitiveToggle?: boolean;
}

export function DemoModeHeaderControls({ showSensitiveToggle = true }: DemoModeHeaderControlsProps) {
  return (
    <div className="flex items-center gap-2">
      {/* Hidden buttons - kept in code for future use */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => {
          alert('Feedback form would open here');
        }}
        className="hidden"
      >
        <MessageSquare className="h-4 w-4 mr-1.5" />
        Send Feedback
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => {
          alert('Learn more documentation would open here');
        }}
        className="hidden"
      >
        <BookOpen className="h-4 w-4 mr-1.5" />
        Learn More
      </Button>
      {/* Data Sensitivity Toggle - only shown on pages with financial data */}
      {showSensitiveToggle && <SensitiveDataToggle />}
    </div>
  );
}
